<template>
  <div class="view match">
    <div style="margin: auto;">
      <img style="width: 100%;"  :src="image_url">
      <!--<Media-->
      <!--v-if="safaricom"-->
      <!--:kind="'video'"-->
      <!--:src="video_url"-->
      <!--:autoplay="true"-->
      <!--muted-->
      <!--playsinline-->
      <!--:controls="true"-->
      <!--:loop="false"-->
      <!--:ref="'fish'"-->
      <!--:style="{width: '100%'}"-->
      <!--@ended="advance()"-->
      <!--@play="playing()"-->
      <!--@playing="playing()"-->
      <!--&gt;-->
      <!--</Media>-->
    </div>

    <div class="container" v-if="!game">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
      <div class="shape shape-4"></div>
    </div>
  </div>

</template>
<script>
import axios from "axios";
import Media from '@dongido/vue-viaudio'
const path = require('../../public/safaricom.mp4')
export default {
  components: {
    Media
  },
  data() {
    return {
      image:false,
      game: true,
      mute:true,//
      image_url:'',
      video_url:['https://drive.google.com/uc?id=1dpvDWRN-U6bhUxk5jDJxX2s1sBJwxnV3']
    }
  },//DATA
  mounted()
  {
    // if (this.$store.state.njugush_video==true)
    // {
    this.image=true;
    if (this.$store.state.matchSlug ==628)
    {
      if(this.$store.state.round ==2) {
        this.image_url = require("@/assets/saru.jpg");
      }
    }
    // if (this.$store.state.matchSlug ==476)
    // {
    //   if(this.$store.state.round ==3)
    //   {
    //     this.image_url = require("@/assets/naivas_promo_1.png");
    //   }else
    //   {
    //     this.image_url = require("@/assets/naivas_promo_2.png");
    //   }
    //
    // }
    //   if (this.$store.state.matchSlug ==331)
    //   {
    //     this.image_url = require("@/assets/didyouknow.jpeg");
    //   }
    //   if (this.$store.state.matchSlug ==333)
    //   {
    //     this.image_url = require("@/assets/nivea.jpg");
    //   }
    //   if (this.$store.state.matchSlug ==323)
    //   {
    //     this.image_url = require("@/assets/tembeao.png");
    //   }
    //   if (this.$store.state.matchSlug ==384)
    //   {
    //     this.image_url = require("@/assets/hanan.png");
    //   }
    //
    // if (this.$store.state.matchSlug ==433)
    // {
    //   this.image_url = require("@/assets/viral-event.jpeg");
    // }








    if (this.$store.state.matchSlug ==1145)
    {
      this.image_url = require("@/assets/copia.jpg");
    }
    if (this.$store.state.matchSlug ==560)
    {
      this.image_url = require("@/assets/copia.jpg");
    }
    if (this.$store.state.matchSlug ==774)
    {
      this.image_url = require("@/assets/his-and-hers.jpeg");
    }
    if (this.$store.state.matchSlug ==789)
    {
      this.image_url = require("@/assets/is-it-known.jpeg");
    }

    if (this.$store.state.matchSlug ==806)
    {
      this.image_url = require("@/assets/safari-orange.jpeg");
    }
    if (this.$store.state.matchSlug == 822)
    {
      this.image_url = require("@/assets/trivia-822.jpeg");
    }
    if (this.$store.state.trivia.creator_id == 7358)
    {
      this.image_url = require("@/assets/maishaFiti.jpeg");
    }
    if (this.$store.state.matchSlug == 838)
    {
      this.image_url = require("@/assets/trivia-838.jpeg");
    }
    if (this.$store.state.matchSlug == 846)
    {
      this.image_url = require("@/assets/trivia846.jpg");
    }
    if (this.$store.state.matchSlug == 853)
    {
      this.image_url = require("@/assets/trivia-853.png");
    }
    if (this.$store.state.matchSlug == 995)
    {
      this.image_url = require("@/assets/trivia-995.jpeg");
    }
    //this.image_url = ['https://drive.google.com/uc?id=1-JYkS8fguck7-TmO871m_XWRWqjZOWev'];
    // }
    // else
    // {
    //   this.image=true;
    // }

    let context = this;
    setTimeout(function(){

      context.advance();

    }, 3000);
    // this.startGame();
    // const api = "https://create.tuni.ke/api/challenge/trivia/game/1to50/get/highscore";
    // let data =  {
    //   'trivia_id': this.$store.state.matchSlug,
    //   'isp':this.$store.state.isp
    // };
    // const qs = require('qs')
    // axios({
    //   method: 'post',
    //   url: api,
    //   data: qs.stringify(data),
    //   headers: {
    //     'content-type': 'application/x-www-form-urlencoded;charset=utf-8'
    //   }
    // }).then(response => {
    //   this.best_time = response.data.data;
    // })
  },
  computed: {
    // helper property to get the non-active player
    safaricom () {
      return this.$store.state.njugush_video;
      //return path
    }
  },
  methods: {
    // notiffy()
    // {
    //   this.game = false;
    //   alert('Ended');
    // },
    playing() {
      //console.log('here............................................')
      var vid = this.$refs.fish
      vid.muted = false
    },
    advance() {
      const vm = this;
      setTimeout(() => {
        vm.game = false;
      }, 1000)
      // Proceed if less than 10 rounds
      if (this.$store.state.round <= (this.$store.state.questions.length - 2)) {
        this.$store.commit('pauseGame');
        //this.playerClickedCard = false;
        this.$store.commit('playerClickedCard', false);
        //this.resultsView = false;
        this.$store.commit('setResults', false);
        //this.timerCount = 30;
        setTimeout(() => {
          vm.$store.commit('setIsOnBreak');
        }, 1500)
      }
    }
  }
};
</script>
<style lang="css" scoped>
* {
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
html, body {
  margin: 0;
  padding: 0;
  background: #faf8ef;
  color: #faf8ef;
  font-size: 18px;
}

body {
  margin: 20px 0;
}

div {
  display: block;
}

.container {
  width: 600px;
  margin: 0px auto;
}

.heading:after {
  content: "";
  display: block;
  clear: both;
}

h1.title {
  font-size: 80px;
  font-weight: bold;
  margin: 0;
  display: block;
  float: left;
}

.scores-container {
  width: 100%;
  text-align: center;
}

.score-container, .best-container {
  position: relative;
  display: inline-block;
  background: #fbb03b;
  padding: 15px;
  font-size: 15px;
  font-weight: bold;
  border-radius: 3px;
  color: white;
  margin:0 10px 0 10px;
  text-align: center;
  width: 120px;
}

.score-container:after, .best-container:after {
  position: absolute;
  width: 100%;
  top: 5px;
  left: 0;
  text-transform: uppercase;
  font-size: 13px;
  line-height: 13px;
  text-align: center;
  color: #eee4da;
}

.score-container:after {
  content: "Time";
}

.best-container:after {
  content: "Best Time";
}

.above-game:after {
  content: "";
  display: block;
  clear: both;
}

.game-intro {
  float: left;
  line-height: 42px;
  margin-bottom: 0;
}

.restart-button {
  display: inline-block;
  background: #002152;
  border-radius: 3px;
  padding: 0 20px;
  text-decoration: none;
  color: #f9f6f2;
  height: 40px;
  line-height: 42px;
  display: block;
  text-align: center;
  float: right;
  cursor: pointer;
}

p {
  margin-top: 0;
  margin-bottom: 10px;
  line-height: 1.65;
}

a {
  font-weight: bold;
  cursor: pointer;
}

.above-game a:hover {
  color: yellow;
}

#game-container {
  background: #fff;
  border-radius: 10px;
  width: 570px;
  height: 570px;
  padding: 20px;
  margin: 15px auto;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  touch-action: none;
}

#tile {
  background: #002152;
  border-radius: 5px;
  width: 100px;
  height: 65px;
  float: left;
  margin: 3px 2px 2px 3px;
  padding: 5px;
  font-size: 35px;
  color: #ffffff;
  cursor: pointer;
  text-align: center;
}

#start-button {
  background: #002152;
  border-radius: 20px;
  vertical-align: middle;
  width: 350px;
  height: 100px;
  font-size: 50px;
  padding: 15px;
  color: #ffffff;
  cursor: pointer;
  text-align: center;
  margin: 190px auto;
}

#timer {
  font-size: 150px;
  text-align: center;
  vertical-align: middle;
  color: #fbb03b;
  margin: 150px auto;
}

#game-over {
  font-size: 50px;
  text-align: center;
  vertical-align: middle;
  color: white;
  margin: 50px auto;
}

#restart-button {
  background: #002152;
  border-radius: 20px;
  vertical-align: middle;
  width: 350px;
  height: 100px;
  font-size: 50px;
  padding: 15px;
  color: #ffffff;
  cursor: pointer;
  text-align: center;
  margin: 50px auto;
}

.footer {
  text-align: center;
}

#fb iframe {
  width: 90px;
  height: 30px;
}


@media only screen and (max-device-width: 480px) {
  html, body {
    margin: 0;
    padding: 0;
    background: #faf8ef;
    color: #faf8ef;
    font-size: 30px;
  }

  body {
    margin: 40px 0;
  }

  div {
    display: block;
  }

  .container {
    width: 800px;
    margin: 0px auto;
  }

  .heading:after {
    content: "";
    display: block;
    clear: both;
  }

  h1.title {
    font-size: 100px;
    font-weight: bold;
    margin: 0;
    display: block;
    float: left;
  }

  .scores-container {
    width: 100%;
    text-align: center;
  }

  .score-container, .best-container {
    position: relative;
    display: inline-block;
    background: #fbb03b;
    padding: 15px;
    font-size: 15px;
    font-weight: bold;
    border-radius: 3px;
    color: white;
    margin: 1px 10px 1px 10px;
    text-align: center;
    width: 120px;
  }

  .score-container:after, .best-container:after {
    position: absolute;
    width: 100%;
    top: 1px;
    left: 0;
    text-transform: uppercase;
    font-size: 12px;
    line-height: 12px;
    text-align: center;
    color: #eee4da;
  }

  .score-container:after {
    content: "Time";
  }

  .best-container:after {
    content: "Best Time";
  }

  .above-game:after {
    content: "";
    display: block;
    clear: both;
  }

  .game-intro {
    float: left;
    width: 55%;
    line-height: 45px;
    margin-bottom: 0;
    margin-top: 20px;
    font-size: 37px;
  }

  .restart-button {
    display: inline-block;
    background: #002152;
    border-radius: 5px;
    padding: 20px;
    text-decoration: none;
    color: #f9f6f2;
    width: 42%;
    height: 90px;
    line-height: 42px;
    display: block;
    text-align: center;
    float: right;
    cursor: pointer;
    margin-top: 20px;
    font-size: 40px;
  }

  p {
    margin-top: 0;
    margin-bottom: 10px;
    line-height: 1.65;
  }

  a {
    font-weight: bold;
    cursor: pointer;
  }

  .above-game a:hover {
    color: yellow;
  }

  #game-container {
    border-radius: 20px;
    width: 100%;
    height: 570px;
    padding: 20px;
    /* margin: 60px auto; */
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    touch-action: none;
  }

  #tile {
    background: #002152;
    border-radius: 10px;
    width: 18%;
    height: 12%;
    float: left;
    margin: 4px 2px 2px 4px;
    padding: 5px;
    font-size: 33px;
    color: #ffffff;
    cursor: pointer;
    text-align: center;
  }

  #start-button {
    background: #002152;
    border-radius: 20px;
    vertical-align: middle;
    width: 500px;
    height: 120px;
    font-size: 60px;
    padding: 15px;
    color: #ffffff;
    cursor: pointer;
    text-align: center;
    margin: 260px auto;
  }

  #timer {
    font-size: 80px;
    text-align: center;
    vertical-align: middle;
    color: #fbb03b;
    margin: 150px auto;
  }

  #game-over {
    font-size: 80px;
    text-align: center;
    vertical-align: middle;
    color: white;
    margin: 70px auto;
  }

  #restart-button {
    background: #002152;
    border-radius: 20px;
    vertical-align: middle;
    width: 450px;
    height: 130px;
    font-size: 70px;
    padding: 15px;
    color: #ffffff;
    cursor: pointer;
    text-align: center;
    margin: 50px auto;
  }

  #fb iframe {
    margin: 50px;
    transform: scale(2.5);
    -ms-transform: scale(2.5);
    -webkit-transform: scale(2.5);
    -o-transform: scale(2.5);
    -moz-transform: scale(2.5);
  }
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
html, body {
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: #03002E;
}

body {
  display: flex;
  justify-content: center;
  align-items: center;
}

* {
  box-sizing: border-box;
}

.container {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 999;
  width: 30px;
  height: 30px;
  border-radius: 15px;
  animation: rotation 1s infinite;
}

.container .shape {
  position: absolute;
  width: 10px;
  height: 10px;
  border-radius: 5px;
}

.container .shape.shape-1 {
  left: 0;
  background-color: #4285F4;
}

.container .shape.shape-2 {
  right: 0;
  background-color: #34A853;
}

.container .shape.shape-3 {
  bottom: 0;
  background-color: #FBBC05;
}

.container .shape.shape-4 {
  bottom: 0;
  right: 0;
  background-color: #EA4335;
}

.container .shape-1 {
  animation: shape1 0.5s infinite alternate;
}

.container .shape-2 {
  animation: shape2 0.5s infinite alternate;
}

.container .shape-3 {
  animation: shape3 0.5s infinite alternate;
}

.container .shape-4 {
  animation: shape4 0.5s infinite alternate;
}

@keyframes rotation {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}

@keyframes shape1 {
  from {
    transform: translate(0, 0);
  }

  to {
    transform: translate(20px, 20px);
  }
}

@keyframes shape2 {
  from {
    transform: translate(0, 0);
  }

  to {
    transform: translate(-20px, 20px);
  }
}

@keyframes shape3 {
  from {
    transform: translate(0, 0);
  }

  to {
    transform: translate(20px, -20px);
  }
}

@keyframes shape4 {
  from {
    transform: translate(0, 0);
  }

  to {
    transform: translate(-20px, -20px);
  }
}
</style>
<style lang="sass" scoped>
.modal-backdrop
  position: fixed
  top: 0
  bottom: 0
  left: 0
  right: 0
  background-color: rgba(0, 0, 0, 0.3)
  display: flex
  justify-content: center
  align-items: center

  .modal
    background: #FFFFFF
    box-shadow: 2px 2px 20px 1px
    overflow-x: auto
    display: flex
    border-bottom: 4px solid #008F41
    width: 80%
    text-align: center
    justify-content: center
    min-height: 130px
    flex-direction: column

  .modal-header, .modal-footer
    padding: 15px
    display: flex

  .modal-header
    border-bottom: 1px solid #eeeeee
    color: #4AAE9B
    justify-content: space-between

  .modal-footer
    border-top: 1px solid #eeeeee
    justify-content: flex-end

  .modal-body
    position: relative
    padding: 20px 10px

  .btn-close
    border: none
    font-size: 20px
    padding: 20px
    cursor: pointer
    font-weight: bold
    color: #4AAE9B
    background: transparent

  .btn-green
    color: white
    background: #4AAE9B
    border: 1px solid #4AAE9B
    border-radius: 2px
</style>
